import { css, SerializedStyles } from '@emotion/react';
import { getSizeValue } from '../../theming';

// Static styles
export const STATIC_STYLES: SerializedStyles = css`
    --scrollbar-width: calc(var(--scrollbar-handle-width) + var(--scrollbar-padding) * 2);

    ::-webkit-scrollbar {
        width: var(--scrollbar-width);
    }

    ::-webkit-scrollbar-thumb {
        background-clip: padding-box;
        border-radius: calc(var(--scrollbar-width) / 2);
        border: solid var(--scrollbar-padding) transparent;

        background-color: var(--hc-color-grey-tint-300);
        &:hover {
            background-color: var(--hc-color-grey-tint-400);
        }
    }

    ::-webkit-scrollbar-track {
        background: transparent;
        border: none;
        margin: 10px 0;
    }
`;

export function useDynamicStyles(
    scrollbarHandleWidth: string | number,
    scrollbarPadding: string | number,
    scrollbarEndMargin: string | number
): React.CSSProperties {
    return {
        '--scrollbar-handle-width': getSizeValue(scrollbarHandleWidth),
        '--scrollbar-padding': getSizeValue(scrollbarPadding),
        '--scrollbar-margin': getSizeValue(scrollbarEndMargin),
    } as React.CSSProperties;
}
